import type { SerializedHardware } from '@enmon/commons/lib/tools';
import { type FilterWithPaginationStateShape, useFilterWithPagination } from 'hooks/useFilterWithPagination';

const STATE_KEY = 'HardwareListFilterState';

export interface HardwareListFilterArguments {
  name?: SerializedHardware['name'];
  externalId?: SerializedHardware['external_id'];
  sort?: string;
  category?: SerializedHardware['category'][];
}

export const DEFAULT_FILTER: HardwareListFilterArguments = {
  name: '',
  externalId: '',
  sort: 'id:asc',
  category: undefined,
};

export type InventorLocationFilterWithPaginationShape = FilterWithPaginationStateShape<HardwareListFilterArguments>;

export const useHardwareListFilterWithPagination = (): InventorLocationFilterWithPaginationShape =>
  useFilterWithPagination(STATE_KEY, DEFAULT_FILTER);
